module.exports = __webpack_public_path__ + "img/sem_imagem.969871de.jpg";